import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["value", "placeholder", "partialPlaceholder", "prefix", "__overrideStyles", "isPlaceholderVisible", "whiteSpace", "withBaseStyles", "mobile"];
import React, { forwardRef } from 'react';
const placeholderHOC = Placeholder => Input => {
  return /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        value,
        placeholder,
        partialPlaceholder,
        prefix,
        __overrideStyles,
        isPlaceholderVisible,
        whiteSpace,
        withBaseStyles,
        mobile
      } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(Placeholder, {
      dataQaType: otherProps.dataQaType && `${otherProps.dataQaType}.placeholder`,
      value,
      placeholder,
      partialPlaceholder,
      prefix,
      minWidth: otherProps.minWidth,
      __overrideStyles,
      withBaseStyles,
      mobile,
      whiteSpace,
      isPlaceholderVisible,
      input: /*#__PURE__*/React.createElement(Input, Object.assign({
        ref: ref,
        value: value,
        prefix: prefix,
        placeholder: placeholder
      }, otherProps))
    });
  });
};
export default placeholderHOC;